/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/purchase_orders-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/purchase_orders-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/purchase_orders-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-purchase_orders-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/purchase_orders.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-08-06T05:36:02.479Z
 * Source config: config/entities/purchase_orders-entity-config.ts
 * Public fields: 72/72 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PurchaseOrdersSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  vendor_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_id field
  po_number: Type.Union([Type.String(), Type.Null()]), // po_number field
  order_date: Type.String(), // order_date field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  delivery_address: Type.Union([Type.String(), Type.Null()]), // delivery_address field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  subtotal: Type.Union([Type.Number(), Type.Null()]), // subtotal field
  tax: Type.Union([Type.Number(), Type.Null()]), // tax field
  shipping: Type.Union([Type.Number(), Type.Null()]), // shipping field
  total: Type.Union([Type.Number(), Type.Null()]), // total field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  created_by: Type.String(), // created_by field
  approved_by: Type.Union([Type.String(), Type.Null()]), // approved_by field
  approved_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // approved_at field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  trig_approved_by_name: Type.Union([Type.String(), Type.Null()]), // trig_approved_by_name field - trigger-populated denormalized field
  vendor_branch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_branch_id field
  trig_vendor_name: Type.Union([Type.String(), Type.Null()]), // trig_vendor_name field - trigger-populated denormalized field
  trig_vendor_code: Type.Union([Type.String(), Type.Null()]), // trig_vendor_code field - trigger-populated denormalized field
  trig_vendor_is_active: Type.Union([Type.Boolean(), Type.Null()]), // trig_vendor_is_active field - trigger-populated denormalized field
  trig_vendor_contact_name: Type.Union([Type.String(), Type.Null()]), // trig_vendor_contact_name field - trigger-populated denormalized field
  trig_vendor_contact_email: Type.Union([Type.String(), Type.Null()]), // trig_vendor_contact_email field - trigger-populated denormalized field
  trig_vendor_contact_phone: Type.Union([Type.String(), Type.Null()]), // trig_vendor_contact_phone field - trigger-populated denormalized field
  trig_vendor_website: Type.Union([Type.String(), Type.Null()]), // trig_vendor_website field - trigger-populated denormalized field
  trig_branch_name: Type.Union([Type.String(), Type.Null()]), // trig_branch_name field - trigger-populated denormalized field
  trig_branch_code: Type.Union([Type.String(), Type.Null()]), // trig_branch_code field - trigger-populated denormalized field
  trig_branch_display_name: Type.Union([Type.String(), Type.Null()]), // trig_branch_display_name field - trigger-populated denormalized field
  trig_branch_contact_name: Type.Union([Type.String(), Type.Null()]), // trig_branch_contact_name field - trigger-populated denormalized field
  trig_branch_contact_email: Type.Union([Type.String(), Type.Null()]), // trig_branch_contact_email field - trigger-populated denormalized field
  trig_branch_contact_phone: Type.Union([Type.String(), Type.Null()]), // trig_branch_contact_phone field - trigger-populated denormalized field
  trig_branch_address: Type.Union([Type.String(), Type.Null()]), // trig_branch_address field - trigger-populated denormalized field
  trig_branch_city: Type.Union([Type.String(), Type.Null()]), // trig_branch_city field - trigger-populated denormalized field
  trig_branch_state: Type.Union([Type.String(), Type.Null()]), // trig_branch_state field - trigger-populated denormalized field
  trig_branch_zip_code: Type.Union([Type.String(), Type.Null()]), // trig_branch_zip_code field - trigger-populated denormalized field
  trig_branch_is_active: Type.Union([Type.Boolean(), Type.Null()]), // trig_branch_is_active field - trigger-populated denormalized field
  trig_branch_is_primary: Type.Union([Type.Boolean(), Type.Null()]), // trig_branch_is_primary field - trigger-populated denormalized field
  trig_vendor_branch_name: Type.Union([Type.String(), Type.Null()]), // trig_vendor_branch_name field - trigger-populated denormalized field
  phase_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // phase_id field
  trig_phase_name: Type.Union([Type.String(), Type.Null()]), // trig_phase_name field - trigger-populated denormalized field
  trig_phase_description: Type.Union([Type.String(), Type.Null()]), // trig_phase_description field - trigger-populated denormalized field
  trig_lot_number: Type.Union([Type.String(), Type.Null()]), // trig_lot_number field - trigger-populated denormalized field
  trig_created_by_name: Type.Union([Type.String(), Type.Null()]), // trig_created_by_name field - trigger-populated denormalized field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  trig_status_name: Type.Union([Type.String(), Type.Null()]), // trig_status_name field - trigger-populated denormalized field
  trig_status_code: Type.Union([Type.String(), Type.Null()]), // trig_status_code field - trigger-populated denormalized field
  trig_status_color: Type.Union([Type.String(), Type.Null()]), // trig_status_color field - trigger-populated denormalized field
  payment_terms: Type.Union([Type.String(), Type.Null()]), // payment_terms field
  trig_job_name: Type.Union([Type.String(), Type.Null()]), // trig_job_name field - trigger-populated denormalized field
  trig_job_number: Type.Union([Type.String(), Type.Null()]), // trig_job_number field - trigger-populated denormalized field
  trig_job_builder_name: Type.Union([Type.String(), Type.Null()]), // trig_job_builder_name field - trigger-populated denormalized field
  trig_job_city: Type.Union([Type.String(), Type.Null()]), // trig_job_city field - trigger-populated denormalized field
  auto_serial_number: Type.Union([Type.Number(), Type.Null()]), // auto_serial_number field - auto-generated by database trigger
  eta: Type.Union([Type.String(), Type.Null()]), // eta field
  fees: Type.Union([Type.String(), Type.Null()]), // fees field
  discounts: Type.Union([Type.String(), Type.Null()]), // discounts field
  tax_rate: Type.Union([Type.Number(), Type.Null()]), // tax_rate field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  payment_terms_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // payment_terms_id field
  trig_payment_terms_name: Type.Union([Type.String(), Type.Null()]), // trig_payment_terms_name field - trigger-populated denormalized field
  trig_payment_terms_code: Type.Union([Type.String(), Type.Null()]), // trig_payment_terms_code field - trigger-populated denormalized field
  is_pick_ticket: Type.Union([Type.Boolean(), Type.Null()]), // is_pick_ticket field
  is_stock: Type.Union([Type.Boolean(), Type.Null()]), // is_stock field
  vendor_order_number: Type.Union([Type.String(), Type.Null()]), // vendor_order_number field
  fob: Type.Union([Type.String(), Type.Null()]), // fob field - F.O.B. terms from the PO header
  ship_via: Type.Union([Type.String(), Type.Null()]), // ship_via field - ship method / carrier from the PO header
  requested_date: Type.Union([Type.String(), Type.Null()]), // requested_date field - requested delivery date, distinct from delivery_date/eta
});

export const CreatePurchaseOrdersSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  vendor_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_id field
  po_number: Type.Union([Type.String(), Type.Null()]), // po_number field
  order_date: Type.String(), // order_date field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  delivery_address: Type.Union([Type.String(), Type.Null()]), // delivery_address field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  subtotal: Type.Union([Type.Number(), Type.Null()]), // subtotal field
  tax: Type.Union([Type.Number(), Type.Null()]), // tax field
  shipping: Type.Union([Type.Number(), Type.Null()]), // shipping field
  total: Type.Union([Type.Number(), Type.Null()]), // total field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  created_by: Type.String(), // created_by field
  approved_by: Type.Union([Type.String(), Type.Null()]), // approved_by field
  approved_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // approved_at field
  vendor_branch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_branch_id field
  phase_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // phase_id field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  payment_terms: Type.Union([Type.String(), Type.Null()]), // payment_terms field
  eta: Type.Union([Type.String(), Type.Null()]), // eta field
  fees: Type.Union([Type.String(), Type.Null()]), // fees field
  discounts: Type.Union([Type.String(), Type.Null()]), // discounts field
  tax_rate: Type.Union([Type.Number(), Type.Null()]), // tax_rate field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  payment_terms_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // payment_terms_id field
  is_pick_ticket: Type.Union([Type.Boolean(), Type.Null()]), // is_pick_ticket field
  is_stock: Type.Union([Type.Boolean(), Type.Null()]), // is_stock field
  vendor_order_number: Type.Union([Type.String(), Type.Null()]), // vendor_order_number field
  fob: Type.Union([Type.String(), Type.Null()]), // fob field - F.O.B. terms from the PO header
  ship_via: Type.Union([Type.String(), Type.Null()]), // ship_via field - ship method / carrier from the PO header
  requested_date: Type.Union([Type.String(), Type.Null()]), // requested_date field - requested delivery date, distinct from delivery_date/eta
});

export const UpdatePurchaseOrdersSchema = Type.Object({
  organization_id: Type.String({ format: "uuid" }), // organization_id field
  vendor_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_id field
  po_number: Type.Union([Type.String(), Type.Null()]), // po_number field
  order_date: Type.String(), // order_date field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  delivery_address: Type.Union([Type.String(), Type.Null()]), // delivery_address field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  subtotal: Type.Union([Type.Number(), Type.Null()]), // subtotal field
  tax: Type.Union([Type.Number(), Type.Null()]), // tax field
  shipping: Type.Union([Type.Number(), Type.Null()]), // shipping field
  total: Type.Union([Type.Number(), Type.Null()]), // total field
  project_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // project_id field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  created_by: Type.String(), // created_by field
  approved_by: Type.Union([Type.String(), Type.Null()]), // approved_by field
  approved_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // approved_at field
  vendor_branch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // vendor_branch_id field
  phase_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // phase_id field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  payment_terms: Type.Union([Type.String(), Type.Null()]), // payment_terms field
  eta: Type.Union([Type.String(), Type.Null()]), // eta field
  fees: Type.Union([Type.String(), Type.Null()]), // fees field
  discounts: Type.Union([Type.String(), Type.Null()]), // discounts field
  tax_rate: Type.Union([Type.Number(), Type.Null()]), // tax_rate field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  payment_terms_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // payment_terms_id field
  is_pick_ticket: Type.Union([Type.Boolean(), Type.Null()]), // is_pick_ticket field
  is_stock: Type.Union([Type.Boolean(), Type.Null()]), // is_stock field
  vendor_order_number: Type.Union([Type.String(), Type.Null()]), // vendor_order_number field
  fob: Type.Union([Type.String(), Type.Null()]), // fob field - F.O.B. terms from the PO header
  ship_via: Type.Union([Type.String(), Type.Null()]), // ship_via field - ship method / carrier from the PO header
  requested_date: Type.Union([Type.String(), Type.Null()]), // requested_date field - requested delivery date, distinct from delivery_date/eta
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PurchaseOrdersRow = Static<typeof PurchaseOrdersSchema>;
export type PurchaseOrdersInsert = Static<typeof CreatePurchaseOrdersSchema>;
export type PurchaseOrdersUpdate = Static<typeof UpdatePurchaseOrdersSchema>;

// Legacy type aliases for backward compatibility
export type PurchaseOrders = PurchaseOrdersRow;
export type CreatePurchaseOrders = PurchaseOrdersInsert;
export type UpdatePurchaseOrders = Static<typeof UpdatePurchaseOrdersSchema>;

// Field configuration metadata
export const PurchaseOrdersFieldConfig = {
  filterable: ['id', 'organization_id', 'vendor_id', 'project_id', 'job_id', 'lot_id', 'vendor_branch_id', 'phase_id', 'status_id', 'payment_terms_id', 'is_pick_ticket', 'is_stock'] as const,
  sortable: ['order_date', 'delivery_date', 'created_at', 'updated_at', 'requested_date'] as const,
  searchable: [] as const,
  required: ['organization_id', 'order_date', 'created_by'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'trig_approved_by_name', 'trig_vendor_name', 'trig_vendor_code', 'trig_vendor_is_active', 'trig_vendor_contact_name', 'trig_vendor_contact_email', 'trig_vendor_contact_phone', 'trig_vendor_website', 'trig_branch_name', 'trig_branch_code', 'trig_branch_display_name', 'trig_branch_contact_name', 'trig_branch_contact_email', 'trig_branch_contact_phone', 'trig_branch_address', 'trig_branch_city', 'trig_branch_state', 'trig_branch_zip_code', 'trig_branch_is_active', 'trig_branch_is_primary', 'trig_vendor_branch_name', 'trig_phase_name', 'trig_phase_description', 'trig_lot_number', 'trig_created_by_name', 'trig_status_name', 'trig_status_code', 'trig_status_color', 'trig_job_name', 'trig_job_number', 'trig_job_builder_name', 'trig_job_city', 'auto_serial_number', 'trig_payment_terms_name', 'trig_payment_terms_code'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface PurchaseOrdersQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface PurchaseOrdersResponse {
  data: PurchaseOrders[] | null;
  error: Error | null;
  count?: number;
}

export interface SinglePurchaseOrdersResponse {
  data: PurchaseOrders | null;
  error: Error | null;
}
